import React, { Fragment, useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, Link, useParams } from "react-router-dom";
import withReducer from "../../../../store/withReducer";
import partnerPromotionReducer from "../../store";
import PreLoader from "../../../../share-components/ui/preLoader";
import Breadcrumbs from "../../../../layout/breadcrumb";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import moment from "moment";
import * as yup from "yup";
import "yup-phone";
import {
  ButtonDropdown,
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Form,
  FormGroup,
  Input,
  Label,
  Nav,
  NavItem,
  NavLink,
  Row,
  Popover,
  PopoverBody,
  PopoverHeader,
  FormFeedback,
  FormText,
  Button,
} from "reactstrap";
import AsyncSelect from "react-select/async";
import Select from "react-select";
import { DatePicker } from "rsuite";
import Switch from "react-switch";
import {
  closeProductListDialog,
  editPartnerPromotion,
  getPartnerPromotionSettings,
  openProductListDialogs,
  setPartnerPromotionSettings,
  setProducts,
  setPromotionsProducts,
  setSearchProductDialog,
  storePartnerPromotion,
  updatePartnerPromotion,
} from "../../store/partnerPromotionSlice";
import PartnerProductsSearchModalWindow from "./PartnerProductSearchModalWindow";
import PartnerProductsJqx from "./PartnerProductsJqx";
import ButtonLoader from "../../../../share-components/ui/buttonLoader";

const marketplaces = [
  { id: 1, name: "Amazon" },
  { id: 2, name: "AliExpress" },
  { id: 3, name: "eBay" },
  { id: 4, name: "Walmart" },
  { id: 5, name: "Etsy" },
  { id: 6, name: "Flipkart" },
  { id: 7, name: "Rakuten" },
  { id: 8, name: "Shopee" },
  { id: 9, name: "Lazada" },
  { id: 10, name: "Newegg" },
];

const customStyles = {
  control: (base) => ({
    ...base,
    minHeight: 30,
    // border: "none",
  }),
};

export const defaultValues = {
  partner: null,
  name: "",
  percentage: "",
  start_date: "",
  end_date: null,
  agreed_by: "",
  is_partner_site_discount: false,
  partner_site_discount_percentage: 0,
  promotion_products: [],
  promotion_products_new: [],
  deleted_products: [],
};

export const schema = yup.object().shape({
  partner: yup.object().required("Partner is required").nullable(),
  name: yup.string().required("Name is required"),
  percentage: yup
    .number()
    .typeError("Percentage must be a number")
    .required("Percentage is required")
    .moreThan(0, "Partner percentage must be greater than 0")
    .max(100, "Percentage cannot be more than 100"),
  start_date: yup
    .date()
    .nullable()
    .required("Start date is required")
    .typeError("Start date is required")
    .when("end_date", (endDate, schema) => (endDate ? schema.max(endDate, "Start date must be before or equal to end date") : schema)),
  end_date: yup
    .date()
    .nullable()
    .required("End date is required")
    .typeError("End date is required")
    .min(yup.ref("start_date"), "End date must be after or equal to start date"),
  agreed_by: yup.object().required("Agreed By is required").nullable(),
  is_partner_site_discount: yup.boolean().required(),
  partner_site_discount_percentage: yup
    .number()
    .typeError("Partner percentage must be a number")
    .when("is_partner_site_discount", {
      is: true,
      then: (schema) =>
        schema
          .required("Partner percentage is required")
          .moreThan(0, "Partner percentage must be greater than 0")
          .max(100, "Partner percentage cannot be more than 100"),
      otherwise: (schema) => schema.notRequired().nullable(),
    }),
});

function PartnerPromotionForm() {
  const { id } = useParams();
  let searchProductRef = useRef();
  let infiniteScrollRef = useRef();
  const history = useHistory();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);
  const [startDate, setStartDate] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [buttonDisabled, setButtonDisabled] = useState(false);
  const [buttonDisable, setButtonDisable] = useState(false);
  const [allIds, setAllIds] = useState([]);
  const [TableIds, setTableIds] = useState([]);
  const partnerPromotionState = useSelector(({ partnerPromotion }) => partnerPromotion.partnerPromotion);
  const allSettings = useSelector(({ partnerPromotion }) => partnerPromotion.partnerPromotion?.partnerPromotionSetting?.setting);

  const { handleSubmit, formState, reset, register, setValue, getValues, unregister, trigger, control, watch } = useForm({
    mode: "onChange",
    defaultValues,
    resolver: yupResolver(schema),
  });

  useEffect(() => {
    dispatch(getPartnerPromotionSettings()).then((res) => {
      dispatch(setPartnerPromotionSettings(res.payload));
    });
  }, [dispatch]);

  useEffect(() => {
    if (id) {
      if (infiniteScrollRef.current) {
        infiniteScrollRef.current.actionTriggered = false;
      }
      productSearchFunction(false, 1);
    }else{
      setLoading(false)
    }
  }, [id]);

  const isProvideOffer = watch("is_partner_site_discount");

  const { errors } = formState;
  const isError = Object.keys(errors).length > 0;

  const dataMenu = [
    {
      type: 1,
      text: "Partners Promotions",
      link: "/product/partners-promotions",
    },
    {
      type: 0,
      text: `${id ? "Edit" : "Create"} Promotion`,
      link: "",
    },
  ];

  const productSearchFunction = (isConcat, page) => {
    const existingProducts = getValues("promotion_products_new") || [];
    // setLoading(true);
    dispatch(editPartnerPromotion({ id, params: { page } })).then((res) => {
      if (!res.error) {
        if (page === 1) {
          reset(res.payload);

          setValue("partner", {
            value: getValues("partner").id,
            label: getValues("partner").name,
          });
          setValue("agreed_by", {
            value: getValues("agreed_by").id,
            label: getValues("agreed_by").name,
          });
        }
        const promotionProductsIds = (res.payload.promotion_products || []).map((itm) => itm.product);
        const promotionTableIds = (res.payload.promotion_products || []).map((itm) => itm.id);
        setAllIds((prev) => [...prev, ...promotionProductsIds]);
        setTableIds((prev) => [...prev, ...promotionTableIds]);

        if (id) {
          setValue("is_partner_site_discount", res.payload.is_partner_site_discount === 0 ? false : true);
        } else {
          setValue("is_partner_site_discount", getValues("is_partner_site_discount") === 0 ? false : true);
        }
        if (isConcat) {
          dispatch(
            setPromotionsProducts({
              data: [...partnerPromotionState.promotions_products.data, ...res.payload.promotion_products],
              pagination: { ...partnerPromotionState.promotions_products.pagination, ...res.payload.pagination },
            })
          );
          setValue("promotion_products_new", [...existingProducts, ...res.payload.promotion_products]);
          trigger("promotion_products_new");
        } else {
          dispatch(setPromotionsProducts({ data: res.payload.promotion_products, pagination: res.payload.pagination }));
          setValue("promotion_products_new", res.payload.promotion_products || []);
          trigger("promotion_products_new");
        }
        setLoading(false);
      }
    });
  };

  const fetchProductData = () => {
    productSearchFunction(true, partnerPromotionState.promotions_products.pagination.next_page);
  };

  const calculatePriceAfterDiscount = (discount = 0,itemPrice, salePrice) => {
    let price = itemPrice === null ? salePrice : itemPrice;
    return +(price * (1 - discount / 100)).toFixed(2);
  };

  const openSearchProductDialog = (event) => {
    const obj = { props: { isOpen: true }, data: { searchValue: searchProductRef.current.value } };

    dispatch(setSearchProductDialog(obj));

    // setSearchTerm(event.target.value);
    // dispatch(openProductListDialogs(obj));
  };

  const filteredPartnersOptions = allSettings?.partners
    .filter((type) => type.name.toLowerCase())
    .map((type) => ({
      value: type.id,
      label: type.name,
    }));

  const agreedByPartnersOptions = allSettings?.users
    .filter((user) => user.name?.toLowerCase() && (user.role?.id === 1 || user.role?.id === 2))
    .map((type) => ({
      value: type.id,
      label: type.name,
    }));

  const onSubmitForm = (data) => {
    setButtonDisabled(true);
    let updatedItems = [];
    let deletedItems = [];
    const allProducts = getValues("promotion_products_new");
    const allProductIds = getValues("promotion_products_new").map((item) => item.product);
    const allTableIds = getValues("promotion_products_new").map((item) => item.id);

    if (id) {
      const allExist = allProductIds.every((id) => allIds.includes(id));
      if (!allExist) {
        updatedItems = allProducts.filter((item) => !allIds.includes(item.product));
      }
      deletedItems = TableIds.filter((id) => !allTableIds.includes(id));
    } else {
      updatedItems = getValues("promotion_products_new");
    }
    let promotionProducts = updatedItems.map((ordr) => {
      return {
        ...(id && { id: ordr.id || null }),
        product: ordr.product,
        variant: ordr.variant,
        rrp: ordr.rrp || null,
        price: ordr.price || null,
        sale_price: ordr.sale_price || null,
        cost_price: ordr.cost_price || null,
        percentage: data.percentage,
        promotion: calculatePriceAfterDiscount(data.percentage, ordr.price, ordr.sale_price),
      };
    });

    let promotionData = {
      name: data.name,
      partner: data.partner?.value,
      start_date: moment(data.start_date).format("YYYY-MM-DD HH:mm:ss"),
      end_date: moment(data.end_date).format("YYYY-MM-DD HH:mm:ss"),
      agreed_by: data.agreed_by?.value,
      percentage: data.percentage,
      is_partner_site_discount: data.is_partner_site_discount === true ? 1 : 0,
      partner_site_discount_percentage: data.partner_site_discount_percentage ?? null,
      promotion_products: promotionProducts,
      ...(id && { deleted_products: deletedItems }),
    };

    if (id) {
      dispatch(updatePartnerPromotion({ id, promotionData })).then((res) => {
        if (!res.error) {
          setButtonDisabled(false);
          history.push("/product/partners-promotions");
        } else {
          setButtonDisabled(false);
          console.error("Failed to update promotion:", res.error);
        }
      });
    } else {
      dispatch(storePartnerPromotion(promotionData)).then((res) => {
        if (!res.error) {
          setButtonDisabled(false);
          history.push("/product/partners-promotions");
        } else {
          setButtonDisabled(false);
          console.error("Failed to store promotion:", res.error);
        }
      });
    }
  };

  return (
    <Fragment>
      {loading ? (
        <>
          <PreLoader></PreLoader>
        </>
      ) : (
        <>
          <Breadcrumbs title={`${id ? "Edit" : "Create"} Promotion`} data={dataMenu} />
          <Container fluid={true} className="product-wrapper">
            <div className="product-grid partner-promotion-container">
              <Form onSubmit={handleSubmit(onSubmitForm)}>
                <div className="partner-promotion-form">
                  <Card style={{ padding: 24 }}>
                    <div className="invalid-feedback">{errors.partner && errors.partner.message}</div>
                    <Col sm="12">
                      <Row>
                        <Col md={4}>
                          <FormGroup>
                            <Label className="form-label">
                              Partner Name<span style={{ color: "red" }}>*</span>
                            </Label>
                            <Select
                              placeholder={<div>Filter By Partner</div>}
                              className="select2-filter"
                              isClearable
                              value={watch("partner")}
                              cacheOptions
                              styles={{
                                ...customStyles,
                                menuPortal: (base) => ({ ...base, zIndex: 999999 }),
                                menu: (base) => ({
                                  ...base,
                                  marginTop: 0,
                                }),
                              }}
                              menuPortalTarget={document.body}
                              options={filteredPartnersOptions}
                              onChange={(e) => {
                                setValue("partner", e);
                              }}
                              components={{
                                IndicatorSeparator: () => null,
                              }}
                            />
                            <div style={{ color: "red", fontSize: 12 }}>{errors.partner?.message}</div>
                          </FormGroup>
                        </Col>
                        <Col md={4}>
                          <FormGroup>
                            <Label className="form-label">
                              Name<span style={{ color: "red" }}>*</span>
                            </Label>
                            <input
                              name="name"
                              type="text"
                              style={{ fontSize: "0.8rem", height: "38px" }}
                              className={`form-control ${errors.name ? "is-invalid" : ""}`}
                              placeholder="Promotion Name"
                              {...register("name")}
                            />
                            <div className="invalid-feedback">{errors.name?.message}</div>
                          </FormGroup>
                        </Col>
                        <Col md={4}>
                          <FormGroup>
                            <Label className="form-label">
                              Percentage<span style={{ color: "red" }}>*</span>
                            </Label>
                            <input
                              name="percentage"
                              type="text"
                              style={{ fontSize: "0.8rem", height: "38px" }}
                              className={`form-control ${errors.percentage ? "is-invalid" : ""}`}
                              placeholder="Percentage"
                              {...register("percentage")}
                            />
                            <div className="invalid-feedback">{errors.percentage?.message}</div>
                          </FormGroup>
                        </Col>
                        <Col md={4}>
                          <FormGroup>
                            <Label className="form-label">
                              Start Date<span style={{ color: "red" }}>*</span>
                            </Label>
                            <DatePicker
                              format="yyyy-MM-dd HH:mm:ss"
                              className="custom-date-picker"
                              placeholder="Start date and time"
                              showMeridian={false}
                              style={{ width: "100%" }}
                              // disabledDate={(date) => moment(date).isBefore(moment(), "day")}
                              onChange={(date) => {
                                setValue("start_date", date);
                                trigger(["start_date"]);
                              }}
                              value={watch("start_date") ? moment(watch("start_date")).toDate() : null}
                            />
                            <div style={{ color: "red", fontSize: 12 }}>{errors.start_date?.message}</div>
                          </FormGroup>
                        </Col>
                        <Col md={4}>
                          <FormGroup>
                            <Label className="form-label">
                              End Date<span style={{ color: "red" }}>*</span>
                            </Label>
                            <DatePicker
                              format="yyyy-MM-dd HH:mm:ss"
                              placeholder="End date and time"
                              className="custom-date-picker"
                              showMeridian={false}
                              // disabledDate={(date) => moment(date).isBefore(moment(), "day")}
                              style={{ width: "100%" }}
                              onChange={(date) => {
                                setValue("end_date", date);
                                trigger(["start_date", "end_date"]);
                              }}
                              value={watch("end_date") ? moment(watch("end_date")).toDate() : null}
                            />
                            <div style={{ color: "red", fontSize: 12 }}>{errors.end_date?.message}</div>
                          </FormGroup>
                        </Col>

                        <Col md={4}>
                          <FormGroup>
                            <Label className="form-label">
                              Agreed By<span style={{ color: "red" }}>*</span>
                            </Label>
                            <Select
                              placeholder={<div>Agreed By</div>}
                              className="select2-filter"
                              isClearable
                              cacheOptions
                              styles={{
                                ...customStyles,
                                menuPortal: (base) => ({ ...base, zIndex: 999999 }),
                                menu: (base) => ({
                                  ...base,
                                  marginTop: 0,
                                }),
                              }}
                              menuPortalTarget={document.body}
                              value={watch("agreed_by")}
                              options={agreedByPartnersOptions}
                              onChange={(e) => {
                                setValue("agreed_by", e);
                              }}
                              components={{
                                IndicatorSeparator: () => null,
                              }}
                            />
                            <div style={{ color: "red", fontSize: 12 }}>{errors.agreed_by?.message}</div>
                          </FormGroup>
                        </Col>

                        <Col md={4}>
                          <FormGroup className="d-flex flex-column ">
                            <Label className="form-label mb-2">Is Partner offering discount on their site ?</Label>
                            <Controller
                              name="is_partner_site_discount"
                              control={control}
                              defaultValue={getValues("is_partner_site_discount")}
                              render={({ field }) => (
                                <Switch
                                  checked={field.value}
                                  onChange={field.onChange}
                                  uncheckedIcon={false}
                                  checkedIcon={false}
                                  onColor="#4cd964"
                                  offColor="#ccc"
                                  height={22}
                                  width={42}
                                  handleDiameter={20}
                                />
                              )}
                            />
                            <div style={{ color: "red", fontSize: 12 }}>{errors.is_partner_site_discount?.message}</div>
                          </FormGroup>
                        </Col>

                        {isProvideOffer && (
                          <Col md={4}>
                            <FormGroup>
                              <Label className="form-label">
                                Partner Side Percentage Discount<span style={{ color: "red" }}>*</span>
                              </Label>
                              <input
                                name="partner_site_discount_percentage"
                                type="text"
                                style={{ fontSize: "0.8rem", height: "38px" }}
                                className={`form-control ${errors.partner_site_discount_percentage ? "is-invalid" : ""}`}
                                placeholder="Percentage"
                                {...register("partner_site_discount_percentage")}
                              />
                              <div style={{ color: "red", fontSize: 12 }}>{errors.partner_site_discount_percentage?.message}</div>
                            </FormGroup>
                          </Col>
                        )}
                      </Row>
                    </Col>
                  </Card>
                </div>
                <Card style={{ padding: 24 }}>
                  <h5>Products</h5>
                  <Row style={{ marginBottom: "1rem" }}>
                    <Col sm={10}>
                      <Input
                        type="text"
                        placeholder="Search Products"
                        name="products"
                        ref={(ref) => {
                          searchProductRef.current = ref;
                        }}
                        onKeyUp={openSearchProductDialog}
                        value={searchTerm}
                      />
                    </Col>
                    <Col sm={2}>
                      <Button color="primary" onClick={openSearchProductDialog}>
                        Browse
                      </Button>
                    </Col>
                  </Row>

                  {(getValues("promotion_products_new") || []).length > 0 ? (
                    <Row>
                      <Col md={12}>
                        <PartnerProductsJqx
                          setValue={setValue}
                          getValues={getValues}
                          watch={watch}
                          trigger={trigger}
                          partnerProducts={getValues("promotion_products_new") || []}
                          setButtonDisable={setButtonDisable}
                          isDelete
                          infiniteScrollRef={infiniteScrollRef}
                          fetchProductData={fetchProductData}
                          partnerPromotionState={partnerPromotionState}
                        />
                      </Col>
                    </Row>
                  ) : id ? (
                    <p style={{ textAlign: "center", width: "100%" }}>No any products !</p>
                  ) : null}

                  {getValues("promotion_products").length > 0 && (
                    <div className="mt-3 d-flex justify-content-end">
                      <ButtonLoader
                        color="primary"
                        disabled={buttonDisabled}
                        type="submit"
                        btntext={`${id ? "Update" : "Save"}`}
                        className="btn btn-primary"
                      />
                    </div>
                  )}
                </Card>
              </Form>
            </div>
          </Container>
        </>
      )}

      <PartnerProductsSearchModalWindow setValue={setValue} getValues={getValues} trigger={trigger} searchTerm={searchTerm} />
    </Fragment>
  );
}

export default withReducer([{ partnerPromotion: partnerPromotionReducer }])(PartnerPromotionForm);
